var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { PureComponent } from 'react';
import Mask from './Mask';
import { Button } from '../Button/Button';
import { CloseOutlined } from '@feb-team/legao-icons-react';
import { defaultProps } from './defaults';
import ReactDOM from 'react-dom';
import Transition from '../../components/Transition';
import { InfoOutlined, SuccessOutlined, WarnOutlined, ErrorOutlined, } from '@feb-team/legao-icons-react';
import classNames from 'classnames';
import { DivTag } from '../../Utils/AtomicTag';
var icon = {
    info: React.createElement(InfoOutlined, { className: classNames('text-brand-600', 'legao-dialog-icon') }),
    success: React.createElement(SuccessOutlined, { className: classNames('text-succ-900', 'legao-dialog-icon') }),
    warning: React.createElement(WarnOutlined, { className: classNames('text-warn-900', 'legao-dialog-icon') }),
    error: React.createElement(ErrorOutlined, { className: classNames('text-error-900', 'legao-dialog-icon') }),
};
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: _this.props.visible,
        };
        return _this;
    }
    Dialog.prototype.componentDidMount = function () {
        window.addEventListener('keydown', this.onWrapperKeyDown.bind(this));
    };
    Dialog.prototype.componentWillUnmount = function () {
        window.removeEventListener('keydown', this.onWrapperKeyDown.bind(this));
    };
    Dialog.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.lockScroll) {
            if (this.props.visible) {
                this.open();
            }
        }
    };
    Dialog.prototype.open = function () {
        this.setState({ value: true });
        document.body.classList.add('overflow-hidden');
    };
    Dialog.prototype.close = function () {
        var _a, _b;
        if (this.state.value) {
            this.setState({ value: false });
            document.body.classList.remove('overflow-hidden');
            (_b = (_a = this.props).onAnimationClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    };
    Dialog.prototype.DialogContent = function (props) {
        var type = props.type, title = props.title, showClose = props.showClose, content = props.content, children = props.children, onCancel = props.onCancel, iconHtml = props.icon, onClose = props.onClose;
        if (type) {
            var Icon = icon[type];
            if (typeof iconHtml === 'object' && iconHtml !== null) {
                iconHtml.props = {
                    className: 'legao-dialog-icon',
                };
                Icon = iconHtml;
            }
            return (React.createElement("div", { className: "legao-dialog-type" },
                iconHtml !== null && Icon,
                showClose && (React.createElement(CloseOutlined, { onClick: function () {
                        onClose && onClose();
                        onCancel && onCancel();
                    }, className: "legao-dialog-close" })),
                React.createElement("div", { className: "legao-dialog-content" },
                    title && React.createElement("p", { className: "legao-dialog-title " }, title),
                    React.createElement("span", { className: "legao-dialog-desc" }, content || children))));
        }
        else {
            return (React.createElement(React.Fragment, null,
                title && (React.createElement("div", { className: "legao-dialog-header legao-dialog-header-type" },
                    React.createElement("span", { className: "legao-dialog-title" }, title))),
                showClose && (React.createElement(CloseOutlined, { onClick: function () {
                        onClose && onClose();
                        onCancel && onCancel();
                    }, className: "legao-dialog-close" })),
                React.createElement("div", { className: "legao-dialog-body" },
                    React.createElement("span", { className: "legao-dialog-desc" }, content || children))));
        }
    };
    Dialog.prototype.onWrapperKeyDown = function (e) {
        if (this.props.closeOnPressEscape && e.keyCode === 27) {
            e.stopPropagation();
            this.cancelHandler();
            return;
        }
    };
    Dialog.prototype.cancelHandler = function () {
        var _a, _b, _c, _d;
        (_b = (_a = this.props).onBeforeCancel) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_d = (_c = this.props).onCancel) === null || _d === void 0 ? void 0 : _d.call(_c);
    };
    Dialog.prototype.render = function () {
        var _this = this;
        var _a = this.props, onOk = _a.onOk, onCancel = _a.onCancel, onCancelBtn = _a.onCancelBtn, visible = _a.visible, okText = _a.okText, cancelText = _a.cancelText, mask = _a.mask, confirmLoading = _a.confirmLoading, noCancelBtn = _a.noCancelBtn, noOkBtn = _a.noOkBtn, maskClosable = _a.maskClosable, footer = _a.footer, showClose = _a.showClose, noFooter = _a.noFooter, reverseBtns = _a.reverseBtns, closeOnPressEscape = _a.closeOnPressEscape, lockScroll = _a.lockScroll, width = _a.width, maskStyle = _a.maskStyle, okBtnDisabled = _a.okBtnDisabled, onBeforeCancel = _a.onBeforeCancel, onAnimationClose = _a.onAnimationClose, onCancelHandler = _a.onCancelHandler, className = _a.className, style = _a.style, content = _a.content, title = _a.title, rest = __rest(_a, ["onOk", "onCancel", "onCancelBtn", "visible", "okText", "cancelText", "mask", "confirmLoading", "noCancelBtn", "noOkBtn", "maskClosable", "footer", "showClose", "noFooter", "reverseBtns", "closeOnPressEscape", "lockScroll", "width", "maskStyle", "okBtnDisabled", "onBeforeCancel", "onAnimationClose", "onCancelHandler", "className", "style", "content", "title"]);
        var value = this.state.value;
        var styleObj = __assign(__assign({}, style), { display: value ? 'block' : 'none' });
        var node = (React.createElement(DivTag, { name: Dialog.NAME, className: "legao-dialog-wrapper", onKeyDown: this.onWrapperKeyDown.bind(this), style: { display: value ? 'block' : 'none' } },
            mask && (React.createElement(Transition, { in: visible, unmountOnExit: false, classNames: "legao-dialog-mask-animating", onExited: function () {
                    _this.close();
                }, timeout: 200 },
                React.createElement(Mask, { maskStyle: maskStyle, onClick: function () {
                        if (maskClosable) {
                            _this.cancelHandler();
                        }
                    }, visible: value }))),
            React.createElement(Transition, { in: visible, unmountOnExit: false, classNames: "legao-dialog-animating", timeout: 200, onExited: function () {
                    _this.close();
                } },
                React.createElement(DivTag, __assign({ style: styleObj, className: "legao-dialog-wrap " + (className || '') }, rest),
                    React.createElement(DivTag, { className: "legao-dialog", style: { width: width + 'px' } },
                        React.createElement(this.DialogContent, __assign({}, this.props, { cancelHandler: this.cancelHandler.bind(this) })),
                        noFooter && (React.createElement(DivTag, { className: "legao-dialog-footer", style: { borderTop: !footer && !noCancelBtn && !noOkBtn ? 0 : null } }, footer ? (footer) : (React.createElement(DivTag, { className: "text-right inline-flex " + (reverseBtns ? 'flex-row-reverse' : '') },
                            noOkBtn && (React.createElement(Button, { disabled: okBtnDisabled, loading: confirmLoading, className: "ml-px-8", type: "info", onClick: function () {
                                    onOk === null || onOk === void 0 ? void 0 : onOk();
                                } }, okText)),
                            noCancelBtn && (React.createElement(Button, { className: "ml-px-8", onClick: function () {
                                    onCancelBtn === null || onCancelBtn === void 0 ? void 0 : onCancelBtn();
                                    _this.cancelHandler();
                                } }, cancelText)))))))))));
        return ReactDOM.createPortal(node, document.body);
    };
    Dialog.defaultProps = defaultProps;
    Dialog.NAME = 'dialog';
    Dialog.displayName = 'Dialog';
    return Dialog;
}(PureComponent));
export default Dialog;
Dialog.create = function (props) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    var called = false;
    function destroy() {
        ReactDOM.unmountComponentAtNode(div);
        if (div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    var Container = function () {
        var _a = __read(React.useState(false), 2), show = _a[0], setShow = _a[1];
        var onOk = props.onOk, onCancel = props.onCancel, onCancelBtn = props.onCancelBtn, onAnimationClose = props.onAnimationClose, rest = __rest(props, ["onOk", "onCancel", "onCancelBtn", "onAnimationClose"]);
        return (React.createElement(Dialog, __assign({}, rest, { ref: function () {
                if (called)
                    return;
                called = true;
                setShow(true);
            }, onOk: function () {
                setShow(false);
                onOk === null || onOk === void 0 ? void 0 : onOk();
            }, onCancel: function () {
                setShow(false);
                onCancel === null || onCancel === void 0 ? void 0 : onCancel();
            }, onCancelBtn: function () {
                setShow(false);
                onCancelBtn === null || onCancelBtn === void 0 ? void 0 : onCancelBtn();
            }, onAnimationClose: function () {
                destroy();
            }, visible: show })));
    };
    ReactDOM.render(React.createElement(Container, null), div);
};
Dialog.confirm = function (props) {
    var newProps = Object.assign({}, props, { type: 'warning' });
    Dialog.create(newProps);
};
Dialog.warning = function (props) {
    var newProps = Object.assign({}, props, { type: 'warning', noCancelBtn: false });
    Dialog.create(newProps);
};
Dialog.info = function (props) {
    var newProps = Object.assign({}, props, { type: 'info', noCancelBtn: false });
    Dialog.create(newProps);
};
Dialog.success = function (props) {
    var newProps = Object.assign({}, props, { type: 'success', noCancelBtn: false });
    Dialog.create(newProps);
};
Dialog.error = function (props) {
    var newProps = Object.assign({}, props, { type: 'error', noCancelBtn: false });
    Dialog.create(newProps);
};
